declare namespace $ {

	type $mol_view__sub_shm_hitalama_map_widget_float_viewport_frame_number_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_viewport_frame_number['menu_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_scroll__sub_shm_hitalama_map_widget_float_viewport_frame_number_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	export class $shm_hitalama_map_widget_float_viewport_frame_number extends $mol_select {
		Items( ): $mol_view
		Filter( ): any
		Trigger_icon( ): any
		Bubble_pane( ): $mol_scroll
	}
	
}

//# sourceMappingURL=number.view.tree.d.ts.map